import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CONSTANTS from "../util/constants";
import { useLocation, useNavigate } from "react-router-dom";
const DashboardAdmin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let location = useLocation();
  const [showSideBar, setShowSideBar] = useState(false);
  const [loginResponse, setLoginResponse] = useState({});
  const [divisionStatsRes, setDivisionStatsRes] = useState([]);
  const userDivisionStatsResponse = useSelector(
    (state) => state.login.divisionStatsResponse
  );

  const loginResponseState = useSelector((state) => state.login.loginResponse);
  console.log("loginResponseState", loginResponseState);
  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      setLoginResponse(localstorageLR);
    } else {
      navigate("/", { replace: true });
    }
  }, []);

  useEffect(() => {
    if (userDivisionStatsResponse && userDivisionStatsResponse != null) {
      setDivisionStatsRes(userDivisionStatsResponse);
    }
  }, [userDivisionStatsResponse]);

  useEffect(() => {
    dispatch({
      type: CONSTANTS.CONSTANTS_LOGIN.GET_USER_DIVISION_STATS_CALL,
    });
  }, []);

  return (
    <body
      className={
        showSideBar
          ? "g-sidenav-show bg-gray-100 g-sidenav-pinned"
          : "g-sidenav-show bg-gray-100"
      }
    >
      <div
        className="App-container container-fluid"
        style={{ backgroundColor: "#f8f9fa", overflowY: "scroll" }}
      >
        <div className="g-sidenav-show bg-gray-100">
          <aside
            className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3 bg-white"
            style={
              window.innerWidth < 1200
                ? { zIndex: 9999, overflowY: "scroll" }
                : { zIndex: 0, overflowY: "scroll" }
            }
            id="sidenav-main"
          >
            <div
              className="sidenav-header"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <i
                onClick={() => setShowSideBar(!showSideBar)}
                className={
                  window.innerWidth < 1200
                    ? "fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 "
                    : "fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-x d-none d-xl-none"
                }
                aria-hidden="true"
                id="iconSidenav"
              ></i>
              <a className="navbar-brand m-0" target="_blank">
                <img
                  src={require("./../assets/Dashboard/BurtonLogisticsLogo-DarkGray-small.png")}
                  className="navbar-brand-img"
                />
              </a>
            </div>

            <hr
              className="horizontal dark mt-0"
              style={{ backgroundColor: "darkGrey" }}
            />

            <div
              className={
                showSideBar && window.innerWidth < 1200
                  ? "collapse navbar-collapse  w-auto h-auto"
                  : "collapse navbar-collapse  w-auto h-auto"
              }
              id="sidenav-collapse-main"
              style={{ overflowY: "scroll" }}
            >
              {userDivisionStatsResponse &&
              userDivisionStatsResponse?.length > 0
                ? userDivisionStatsResponse?.map((obj, index) => {
                    return (
                      <div
                        style={{ cursor: "pointer" }}
                        className={
                          window.innerWidth < 1200
                            ? "nav-item mobileMenu"
                            : "nav-item d-flex f-direction-row m-2 align-items-center"
                        }
                        onClick={() => {
                          dispatch({
                            type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT
                              .DIVISION_SELECTED,
                            payload: {
                              value: {
                                label:
                                  userDivisionStatsResponse[index]
                                    ?.divisionName,
                                value:
                                  userDivisionStatsResponse[index]?.division_id,
                              },
                            },
                          });
                          const newPayload = {
                            division_id:
                              userDivisionStatsResponse[index]?.division_id,
                            divisionName:
                              userDivisionStatsResponse[index]?.divisionName,
                            is_active:
                              userDivisionStatsResponse[index]?.is_active,
                            createdAt:
                              userDivisionStatsResponse[index]?.createdAt,
                            updatedAt:
                              userDivisionStatsResponse[index]?.updatedAt,
                          };
                          let newUserAdminData = loginResponseState;
                          newUserAdminData.user.division = newPayload;
                          newUserAdminData.user.division_id =
                            userDivisionStatsResponse[index]?.division_id;

                          console.log("newUserAdminData", newUserAdminData);

                          dispatch({
                            type: CONSTANTS.CONSTANTS_LOGIN
                              .UPDATE_LOGIN_RESPONSE,
                            payload: { value: newUserAdminData },
                          });

                          navigate("/Dashboard", {
                            state: {
                              dc_selected: userDivisionStatsResponse[index],
                            },
                          });
                        }}
                      >
                        <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-1 ms-2 d-flex align-items-center justify-content-center">
                          <img
                            src={require("./../assets/Dashboard/ruralHall.png")}
                          ></img>
                        </div>

                        <h6
                          className="nav-link-text ms-2   text-uppercase text-sm opacity-7 mt-2"
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            textDecorationLine: "underline",
                            color: "blue",
                          }}
                        >
                          {" "}
                          {userDivisionStatsResponse[index].divisionName}
                        </h6>
                        <h6
                          className="nav-link-text ms-2 me-4  text-uppercase text-sm opacity-7 mt-2"
                          style={{ color: "black", fontWeight: "bold" }}
                        >
                          {" "}
                          {": " +
                            userDivisionStatsResponse[index].trailer_count}
                        </h6>
                      </div>
                    );
                  })
                : null}

              <div
                className={
                  window.innerWidth < 1200
                    ? "nav-item mt-3 mobileMenu"
                    : "d-flex f-direction-row m-2 align-items-center mt-3 "
                }
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div
                  className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-1  ms-2 d-flex align-items-center justify-content-center"
                  onClick={() => {
                    localStorage.clear();
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGOUT,
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL,
                      payload: { value: "" },
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD,
                      payload: { value: "" },
                    });
                    navigate(-1);
                  }}
                >
                  <img src={require("./../assets/Dashboard/logout1.png")}></img>
                </div>
                <h6
                  onClick={() => {
                    localStorage.clear();
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.USER_LOGOUT,
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_EMAIL,
                      payload: { value: "" },
                    });
                    dispatch({
                      type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_UPDATE_PASSWORD,
                      payload: { value: "" },
                    });
                    navigate(-1);
                  }}
                  className="nav-link-text ms-2 me-4 mt-1 text-uppercase text-sm   opacity-7"
                  style={{ color: "black" }}
                >
                  LogOut
                </h6>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </body>
  );
};
export default DashboardAdmin;
